export default "__VITE_ASSET__mD5WNGko__"